// Funzione per ottenere la data odierna in formato YYYY-MM-DD
export const getToday = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

// Funzione per formattare la data in formato leggibile (DD/MM/YYYY)
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
};

// Funzione per formattare un numero come valuta Euro
export const formatCurrency = (value) => {
  if (!value && value !== 0) return '';
  
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR'
  }).format(value);
};

// Funzione per convertire le date per Supabase (da YYYY-MM-DD a formato ISO)
export const formatDateForSupabase = (dateString) => {
  if (!dateString) return null;
  return new Date(dateString).toISOString();
};

// Funzione per convertire i record da Supabase al formato dell'app
export const mapContattoFromSupabase = (contatto) => {
  if (!contatto) return null;
  
  return {
    id: contatto.id,
    nome: contatto.nome || '',
    cognome: contatto.cognome || '',
    azienda: contatto.azienda || '',
    telefono: contatto.telefono || '',
    indirizzo: contatto.indirizzo || '',
    email: contatto.email || '',
    isCliente: contatto.is_cliente || false,
    isVettore: contatto.is_vettore || false
  };
};

export const mapMagazzinoFromSupabase = (magazzino) => {
  if (!magazzino) return null;
  
  return {
    id: magazzino.id,
    nome: magazzino.nome || ''
  };
};

export const mapViaggioFromSupabase = (viaggio) => {
  if (!viaggio) return null;
  
  return {
    id: viaggio.id,
    data: viaggio.data || '',
    clienteId: viaggio.cliente_id || '',
    vettoreId: viaggio.vettore_id || '',
    magazzinoCarico: viaggio.magazzino_carico_id || '',
    magazzinoScarico: viaggio.magazzino_scarico_id || '',
    prezzoCliente: viaggio.prezzo || '',
    prezzoVettore: viaggio.prezzo_vettore || '',
    bancali: viaggio.bancali || '26',
    note: viaggio.note || ''
  };
};

// Funzione per formattare un nome completo
export const formatFullName = (nome, cognome, azienda) => {
  const nomeCognome = [nome, cognome].filter(Boolean).join(' ');
  if (azienda && nomeCognome) {
    return `${azienda} (${nomeCognome})`;
  }
  return azienda || nomeCognome || '';
};